import React from 'react';
import './HeadlineSubtitle.scss';
export const HeadlineSubtitle = ({ children, className, ...props }) => (
    <p className={`headline-subtitle ${className || ''}`} {...props}>
        {children}
    </p>
);
